'use client'

import { useIntersectionObserver } from 'hooks/useIntersectionObserver/useIntersectionObserver'
import React, { useEffect, useRef } from 'react'

import { MODULES_PAGINATION_INCREMENT } from '../../constants/modules'
import { useInspirationalProvider } from '../../context/InspirationalProvider/useInspirationalProvider'

export const PaginationObserver = () => {
	const observerRef = useRef<HTMLDivElement>(null)
	const { allModulesAreVisible, incVisibleModules } = useInspirationalProvider()

	const entry = useIntersectionObserver(observerRef, {
		freezeOnceVisible: allModulesAreVisible,
	})

	useEffect(() => {
		if (entry?.isIntersecting) {
			incVisibleModules(MODULES_PAGINATION_INCREMENT)
		}
	}, [allModulesAreVisible, entry?.isIntersecting, incVisibleModules])

	if (allModulesAreVisible) {
		return null
	}

	return <div ref={observerRef} role='presentation' />
}
